import useTranslation from '~/hooks/useTranslation';
import sidebarPriceStyles from '~/styles/bookingFlow/sidebar-price.module.css';
import PriceStatistic from '~/components/BookingFlow/PriceStatistic';
import { Summary } from '~/types/api';

type Props = {
  summary: Summary;
};

export default function SidebarPrice({
  summary,
}: Props) {
  const translate = useTranslation();

  if (!summary) {
    return null;
  }

  return (
    <div className={sidebarPriceStyles.sidebarPrice}>
      <h2 className={sidebarPriceStyles.sidebarPriceHeading}>
        {translate('bookingFlow.sidebar.price')}
      </h2>

      <PriceStatistic
        lines={summary.lines}
        total={summary.total}
      />
    </div>
  );
}
